import axios, {AxiosError, AxiosRequestHeaders} from "axios";
import rateLimit from "axios-rate-limit";
import detectLanguage from "webapp-react/src/utils/locale";
// import axiosRetry from "axios-retry";

export const httpAxiosApi = rateLimit(axios.create({
  // baseURL: '/',
  // timeout: 30000,
  headers: {
    'X-Application': 'Capitalist Application',
    'X-Requested-With': 'XMLHttpRequest',
    'X-Agent': 'capitalist-js',
  }
}), {
  maxRequests: 5,
  perMilliseconds: 1000,
});

// axiosRetry(httpAxiosApi, {retries: 0})

// Request interceptor to add X-Language header based on HTML lang attribute
httpAxiosApi.interceptors.request.use((config) => {
  // Get the lang attribute from the HTML tag
  const htmlLang = document?.documentElement?.lang;
  // console.log('httpAxiosApi request interceptor: htmlLang =', htmlLang);

  if (htmlLang && ['ru', 'en'].includes(htmlLang)) {
    // Set the X-Language header
    config.headers['X-Language'] = htmlLang;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

httpAxiosApi.interceptors.response.use((response) => response, (error) => {
  // whatever you want to do with the error
  checkLoginRequiredError(error);
  throw error;
});

const checkLoginRequiredError = (error: AxiosError) => {

  const errorCodes = [401, 403, 429];
  if (error.response && errorCodes.includes(error.response.status)) {
    //console.log('checkLoginRequiredError', error.response.status);
    // check if window.location.pathname starts with '/finance'
    const isSafeToLogoutPath = window.location.pathname !== '/login';
    if (isSafeToLogoutPath/* && (window.location.pathname.startsWith('/finance'))*/) {
      document.cookie = "Capitalist=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      const currentUrl = window.location.pathname + window.location.search;
      window.location.href = `/logout?backUrl=${encodeURIComponent(currentUrl)}`;
    }
  }
}

export default httpAxiosApi;
